module.exports = __webpack_public_path__ + "media/images/twitterColorIcon-6456b1cf.svg";